var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconReportNormal = function SvgIconReportNormal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M19.131 21h-4.348a.872.872 0 0 1-.87-.875V.875c0-.483.389-.875.87-.875h4.348c.48 0 .869.392.869.875v19.25a.872.872 0 0 1-.869.875zm-.87-19.25h-2.609v17.5h2.609V1.75zM12.174 21H7.826a.873.873 0 0 1-.87-.875v-8.75c0-.483.39-.875.87-.875h4.348c.48 0 .87.392.87.875v8.75c0 .483-.39.875-.87.875zm-.869-8.75h-2.61v7h2.61v-7zM5.217 21H.869A.872.872 0 0 1 0 20.125V7c0-.483.389-.875.869-.875h4.348c.481 0 .87.392.87.875v13.125a.872.872 0 0 1-.87.875zM4.348 7.875H1.739V19.25h2.609V7.875z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReportNormal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-report-normal.75257579.svg";
export { ForwardRef as ReactComponent };